<template>
  <div>
    <TopHeader2 underlineItem="وبلاگ"></TopHeader2>
    <section class="logo-header-resp d-md-none my-5">
      <div class="mx-auto">
        <img src="@/assets/images/logos/logoBlack.png" alt="" />
      </div>
    </section>

    <main class="main">
      <PagesPath :items="['مقالات']"></PagesPath>
      <section v-if="categories" class="mb-2">
        <div class="container py-4">
          <div class="d-md-flex d-none justify-content-between">
            <div class="category-group text-right">
              <button
                @click="showPosts(0)"
                :class="{'select-category':categoryId==0}"
                class="weblog-category  py-1 px-4 border-radius7 fontsize-small weight-light ml-3"
              >
                همه مقالات
              </button>
            <template v-for="(category,index) in categories.data">
            
                  <button
                :class="{'select-category':categoryId==category.id}"

                   v-if="index<5"
                :key="index"
                @click="showPosts(category.id)"
                class="weblog-category py-1 px-4 border-radius7 fontsize-small weight-light ml-3"
              >
                {{ category.title }}
              </button>
              
            </template>
              <!--              <button class="weblog-category py-1 px-4 border-radius7 fontsize-small weight-light ml-3"> دندانپزشکی</button>-->
              <!--              <button class="weblog-category py-1 px-4 border-radius7 fontsize-small weight-light ml-3"> دندانپزشکی</button>-->
              <!--              <button class="weblog-category py-1 px-4 border-radius7 fontsize-small weight-light ml-3"> دندانپزشکی</button>-->
            </div>
            <!-- <div class="category-more">
              <button class="more-category py-1 mx-3 bg-none">بیشتر +</button>
            </div> -->
          </div>
          <div
            class="mb-5 px-3 bg-color-lightGray border border-radius7 d-md-none"
          >
            <select v-model="mobileCategory" class="py-2 text-dark bg-none w-100" name="" id="selectLanguage">
                  <option value="firstInit" disabled selected>یک دسته بندی انتخاب کنید</option>
              <option 
              :value="category.id"
                @click="showPosts(category.id)" v-for="(category,index) in categories.data" :key="index" class="fontsize-small weight-light">
                {{category.title}}
              </option>
                     <option 
                     value="0"
            class="fontsize-small weight-light" selected>
                همه
              </option>
            </select>
          </div>
        </div>
      </section>
      <section v-if="posts" class="weblogs-grid container mb-5">
        <article
          v-for="(weblog, index) in posts.data"
          :key="index"
          class="weblog-item text-right border-radius15"
        >
          <div class="weblog-item-img">
            <img
              v-if="weblog.cover == null"
              src="@/assets/images/gallery/photos/pic2.png"
              alt=""
            />
            <img v-else :src="weblog.cover.url" alt="" />
          </div>
          <div class="weblog-item-content p-3 my-auto">
             <router-link :to="`/internal-Weblog/${weblog.id}/${weblog.slug}`" type="button" class="bg-none">
            <h6 class="fontsize-medium text-color-222">{{ weblog.title }}</h6>
             </router-link>
            <div>
              <svg class="icon ml-2" width="16" height="16">
                <use href="@/assets/svgIcons/svgIcons.svg/#time"></use>
              </svg>
              <span class="fontsize-mini text-color-444">{{
                new Date(weblog.published_at).toLocaleDateString("fa")
              }}</span>
            </div>
            <p
              class="fontsize-mini line-height2 text-color-666 text-justify weight-light"
            >
              {{
                weblog.short_description.length > 145
                  ? weblog.short_description.substring(0, 145) + "..."
                  : weblog.short_description
              }}
            </p>
            <div class="text-left">
              <router-link :to="`/internal-Weblog/${weblog.id}/${weblog.slug}`" type="button" class="bg-none">
                <span class="fontsize-mini text-color-666 ml-2">بیشتر</span>
                <svg class="icon" width="12" height="12" stroke="#666">
                  <use href="@/assets/svgIcons/svgIcons.svg/#arrow-left2"></use>
                </svg>
              </router-link>
            </div>
          </div>
        </article>
      </section>
      <div v-if="posts" class="pagination-items" style="z-index: 2">
        <pagination
          :limit="1"
          :data="posts"
          @pagination-change-page="changePage"
          :disabled="disabled"
          class="justify-content-center"
        >
          <span slot="prev-nav">
            <svg
              class="page-arrow"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="20"
              height="20"
              viewBox="0 0 226 226"
              style="fill: #000000"
            >
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray=""
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <path d="M0,226v-226h226v226z" fill="none"></path>
                <g fill="#b2b2b2">
                  <path
                    d="M82.80781,169.67656c1.05938,1.05937 2.47187,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906l52.96875,-52.96875c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-52.96875,-52.96875c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0c-2.11875,2.11875 -2.11875,5.47344 0,7.41563l49.26094,49.26094l-49.26094,49.26094c-2.11875,2.11875 -2.11875,5.29688 0,7.41562z"
                  ></path>
                </g>
              </g>
            </svg>
          </span>
          <span slot="next-nav">
            <svg
              class="page-arrow"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="20"
              height="20"
              viewBox="0 0 226 226"
              style="fill: #000000"
            >
              <g
                fill="none"
                fill-rule="nonzero"
                stroke="none"
                stroke-width="1"
                stroke-linecap="butt"
                stroke-linejoin="miter"
                stroke-miterlimit="10"
                stroke-dasharray=""
                stroke-dashoffset="0"
                font-family="none"
                font-weight="none"
                font-size="none"
                text-anchor="none"
                style="mix-blend-mode: normal"
              >
                <path d="M0,226v-226h226v226z" fill="none"></path>
                <g fill="#b2b2b2">
                  <path
                    d="M143.19219,56.32344c-2.11875,-2.11875 -5.47344,-2.11875 -7.41563,0l-52.96875,52.96875c-2.11875,2.11875 -2.11875,5.47344 0,7.41562l52.96875,52.96875c1.05937,1.05937 2.47188,1.58906 3.70781,1.58906c1.23594,0 2.64844,-0.52969 3.70781,-1.58906c2.11875,-2.11875 2.11875,-5.47344 0,-7.41563l-49.26094,-49.26094l49.26094,-49.26094c2.11875,-2.11875 2.11875,-5.29687 0,-7.41563z"
                  ></path>
                </g>
              </g>
            </svg>
          </span>
        </pagination>
      </div>
      <loader v-else />
    </main>
  </div>
</template>

<script>
import loader from "@/components/loader.vue";

import TopHeader2 from "../components/TopHeader2";
import PagesPath from "../components/PagesPath";
export default {
  name: "Weblogs",
  components: {
    loader,
    TopHeader2,
    PagesPath
  },
    metaInfo() {
    return {
      title:"پست ها",
      
      meta: [
        {
          name: "description",
          content:"پست های آموزشی برای دهان و دندان و مراقب های لازم پزشکی و هزاران نکته آموزشی دیگر در مورد دندان پزشکی لمینت و کامپوزیت "
        },
      ]
    };
  },
  mounted() {
    this.categoryId=this.$route.query.category?this.$route.query.category:0;
    this.$axios.get(`posts?page=${this.$route.query.page?this.$route.query.page:1}${this.$route.query.tag?'&tagId='+this.$route.query.tag:''}${this.$route.query.category?'&categoryId='+this.$route.query.category:''}${this.$route.query.type?'&type='+this.$route.query.type:''}`).then((res) => {
      this.posts = res.data.posts;
    });
    this.$axios.get("/categories").then((res) => {
      this.categories = res.data.categories;
      console.log(this.categories);
    });
    //** Select of Category **//
    const listCategory = document.querySelectorAll(".weblog-category");
    listCategory.forEach((item) => {
      item.addEventListener("click", function () {
        listCategory.forEach((item2) => {
          if (item2.classList.contains("select-category")) {
            item2.classList.remove("select-category");
          }
        });
        if (!item.classList.contains("select-category")) {
          item.classList.add("select-category");
        }
      });
    });

    //** HEight of Img **//
    document.querySelectorAll(".weblog-item-img").forEach((webImg) => {
      webImg.style.height = webImg.offsetWidth + "px";
    });
  },
  
  data() {
    return {
      disabled: false,
      categories: null,
      posts: null,
      currentPage:1,
      mobileCategory:'firstInit',
      categoryId:0,
      flagCategory:false,
    };
  },
  methods: {
    changePage(event) {
      this.currentPage=event;
      if(this.flagCategory){
this.$axios.get(`/posts?page=${this.currentPage}&categoryId=${this.categoryId}`).then((res) => {
          this.posts = res.data.posts;
        });
      }else{

        this.$axios.get(`/posts?page=${event}`).then((res) => {
          this.posts = res.data.posts;
      });
        }
       this.$router.replace({ name: "weblogs",  query: {page:this.currentPage} })
    },
    showPosts(id) {
      this.categoryId=id;
      if (id == 0) {
        this.flagCategory=false;
        this.$axios.get(`/posts?page=${this.currentPage}`).then((res) => {
          this.posts = res.data.posts;
        });
      } else {
        this.flagCategory=true;

         this.$axios.get(`/posts?page=${this.currentPage}&categoryId=${this.categoryId}`).then((res) => {
          this.posts = res.data.posts;
        });
      }
    }
  },
  watch:{
    mobileCategory(newVal){
      this.showPosts(newVal)
    }
  }
};
</script>

<style scoped>
.weblog-category {
  border: 1px solid var(--color-theme);
  background-color: white;
  color: var(--color-theme);
}
.select-category {
  background-color: var(--color-theme);
  color: white;
}
.more-category {
  color: var(--color-theme);
  position: relative;
}
.more-category:after {
  content: "";
  height: 1px;
  width: 100%;
  background-color: var(--color-theme);
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
}
.more-category:hover {
  font-family: font-bold;
}
.more-category:hover:after {
  height: 2px;
}
.weblog-item {
  display: grid;
  grid-template-columns: 35% 65%;
  overflow: hidden;
  border: 1px solid #aaa;
  background-color: white;
}
.weblogs-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1.5rem;
}
.weblog-item-img {
  width: 100%;
}
.weblog-item-img img {
  width: 100%;
  height: 100%;
}
.logo-header-resp > div {
  width: 150px;
}
.logo-header-resp > div img {
  width: 100%;
}
.category-group {
  width: 90%;
  margin-top: 15px;
}
.category-more {
  width: 10%;
}
@media screen and (max-width: 1199px) {
  .weblog-item {
    grid-template-columns: 40% 60%;
  }
}
@media screen and (max-width: 991px) {
  .weblog-item {
    grid-template-columns: 1fr;
  }
  .weblogs-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
  .category-group {
    width: 85%;
  }
  .category-more {
    width: 15%;
  }
}
@media screen and (max-width: 767px) {
  .weblog-item {
    grid-template-columns: 40% 60%;
  }
  .weblogs-grid {
    grid-template-columns: 1fr;
  }
}
@media screen and (max-width: 500px) {
  .weblog-item {
    grid-template-columns: 45% 55%;
  }
}
@media screen and (max-width: 450px) {
  .weblog-item {
    grid-template-columns: 1fr;
  }
  .weblog-item p {
    margin-bottom: 0 !important;
  }
}
</style>
